import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("AdminToken");

  if (!token) {
    return <Navigate to="/log-in" replace />;
  }

  return children;
};

export default ProtectedRoute;